var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoMedia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26197",
    "data-name": "Group 26197",
    transform: "translate(-370 -652)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5813",
    "data-name": "Rectangle 5813",
    width: 48,
    height: 48,
    transform: "translate(370 652)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "no_media",
    transform: "translate(382 664)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Path",
    width: 24,
    height: 24,
    fill: "rgba(0,0,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53061",
    "data-name": "Path 53061",
    d: "M21.9,21.9l-8.49-8.49h0L3.59,3.59h0L2.1,2.1.69,3.51,3,5.83V19a2.006,2.006,0,0,0,2,2H18.17l2.31,2.31ZM5,18l3.5-4.5L11,16.51,12.17,15l3,3Zm16,.17L5.83,3H19a2.006,2.006,0,0,1,2,2Z",
    fill: "#dedede"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoMedia);
export default __webpack_public_path__ + "static/media/no-media.546e0dd1e0506923fe0377d6d522dd03.svg";
export { ForwardRef as ReactComponent };